import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { ModalService } from 'src/app/shared/service/modal.service';
declare var $: any;

@Component({
    selector: 'politicas-modal',
    templateUrl: './politicas.modal.html',
    styleUrls: ['./politicas.modal.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PoliticasModal implements OnChanges{
    @Input('title') title : string;
    constructor(
        public _modal: ModalService
    ) { }

    ngOnChanges(){
        $('#btn-modal').attr('disabled', true);
        if(this.title === 'T'){
            $('#modal').scroll(function() {
                if($(this).scrollTop() + $(this).height() > $('.modal').height()) {
                    $('#btn-modal').attr('disabled', false);
                }
            });
        }else{
            $('#btn-modal').attr('disabled', false);
        }
    }

    closeModal(){
        $('#politicasModal').modal('hide');
    }

    /** Evita que #ancla dispare navegación Angular y scrollea dentro del body del modal. */
    scrollToAnchor(anchorId: string, event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        const target = document.getElementById(anchorId);
        const container = document.getElementById('modal');
        if (!target || !container) {
            return;
        }
        const top =
            target.getBoundingClientRect().top -
            container.getBoundingClientRect().top +
            container.scrollTop -
            8;
        container.scrollTo({ top, behavior: 'smooth' });
    }
}